export interface ParsedKratosError {
  generalMessage: string
  fieldErrors: Record<string, string>
}

export function parseKratosError(error: any): ParsedKratosError {
  const result: ParsedKratosError = {
    generalMessage: "",
    fieldErrors: {},
  }

  if (!error) {
    result.generalMessage = "Произошла неизвестная ошибка при авторизации"
    return result
  }

  // Network / Connection errors
  if (
    error.code === "ECONNREFUSED" ||
    error.code === "ERR_NETWORK" ||
    error.message?.includes("Network Error")
  ) {
    result.generalMessage =
      "Сервер авторизации временно недоступен. Проверьте сетевое соединение кассы."
    return result
  }

  const responseData = error.response?.data

  // Kratos Flow Validation Error (HTTP 400)
  if (responseData?.ui) {
    const ui = responseData.ui

    // Check top-level messages
    if (Array.isArray(ui.messages) && ui.messages.length > 0) {
      const topMessage = ui.messages[0]
      result.generalMessage = localizeKratosMessage(
        topMessage.id,
        topMessage.text
      )
    }

    // Check node-level messages (for specific form fields)
    if (Array.isArray(ui.nodes)) {
      for (const node of ui.nodes) {
        const fieldName = node.attributes?.name
        if (
          fieldName &&
          Array.isArray(node.messages) &&
          node.messages.length > 0
        ) {
          const nodeMessage = node.messages[0]
          const localized = localizeKratosMessage(
            nodeMessage.id,
            nodeMessage.text
          )
          result.fieldErrors[fieldName] = localized
          if (!result.generalMessage) {
            result.generalMessage = localized
          }
        }
      }
    }
  }

  // Fallback messages
  if (!result.generalMessage) {
    if (responseData?.error?.message) {
      result.generalMessage = responseData.error.message
    } else if (error.message) {
      result.generalMessage = error.message
    } else {
      result.generalMessage =
        "Не удалось выполнить вход. Проверьте введенные данные."
    }
  }

  return result
}

function localizeKratosMessage(id: number | undefined, text: string): string {
  // Known Kratos Error IDs
  switch (id) {
    case 4000002: // The password is incorrect
    case 4000006:
      return "Неверный логин или пароль"
    case 4000007:
      return "Учетная запись заблокирована или неактивна. Обратитесь к администратору"
    case 4000010:
      return "Срок действия формы входа истек. Пожалуйста, попробуйте снова"
    case 4000001:
      return "Заполните все обязательные поля"
    default:
      break
  }

  // Common text patterns
  const lowerText = text.toLowerCase()
  if (
    lowerText.includes("password is incorrect") ||
    lowerText.includes("no account found")
  ) {
    return "Неверный логин или пароль"
  }
  if (lowerText.includes("csrf")) {
    return "Ошибка проверки CSRF-токена. Пожалуйста, обновите страницу"
  }
  if (
    lowerText.includes("is missing") ||
    lowerText.includes("must not be empty")
  ) {
    return "Поле обязательно для заполнения"
  }

  return text
}
